import React from 'react'
import classes from './Input.module.css'

const Input = ({className, style, ...rest}) => {
  return (
    <input className={`${classes.input} ${className}`} {...rest} style={style}/>
  )
}

export default Input
